import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './FileUpload.module.scss';
import { toKB } from '../../../components/common/Utility/commonUtils';
import doc_icon from '../../../assets/images/svg/doc.svg';
import delete_icon from '../../../assets/images/svg/delete.svg';
import { testIds } from '../../../constants/testId';
import upload_icon from '../../../assets/images/svg/upload-picture.svg';

const FileUplaod = (props) => {
  const {
    name,
    label,
    onChange = () => { },
    accept,
    meta = {},
    value,
    fileSize,
    extentions = [],
    readOnly,
    required,
    errorCallBack
  } = props;
  const [file, setFile] = useState();
  const [dragActive, setDragActive] = React.useState(false);
  const inputFileRef = useRef();

  const handleOnChange = (event) => {
    const { files } = event && event.target;
    let fileSizeLimit =
      (fileSize && parseInt(fileSize.substring(0, 1)) * 1024 * 1024) || 5 * 1024 * 1024;
    let fileExt = files[0]?.name?.split('.')[files[0].name.split('.').length - 1];
    if (errorCallBack && files[0] && !extentions.includes(fileExt)) {
      errorCallBack({
        message: `File extension should be one of ${accept}`
      });
      return;
    }
    if (errorCallBack && files[0]?.size > fileSizeLimit) {
      errorCallBack({
        message: `Max file upload size is allowed only ${fileSize}`
      });
      return;
    }
    setFile({ fileName: files[0].name, fileSize: toKB(files[0].size) });
    onChange({ name, value: files[0] });
  };

  useEffect(() => {
    if (value) {
      setFile(value);
    } else {
      setFile(null);
    }
    // eslint-disable-next-line
  }, [value]);

  // handle drag events
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  // triggers when file is dropped
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const file = e.dataTransfer.files && e.dataTransfer.files[0];
    if (file) {
      setFile({ fileName: file.name, fileSize: toKB(file.size) });
      onChange({ name, value: file });
    }
  };
  if (readOnly && !value) {
    return <h5 className={styles.notProvided}>NOT PROVIDED</h5>;
  }
  return (
    <div className={styles.wrapper}>
      <h4>
        {label} {required && <span>*</span>}
      </h4>
      {!file && (
        <div
          className={`${styles.uploadWrapper}`}
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
          style={{
            ...(dragActive && { background: '#fff', borderColor: '#14A493' })
          }}
          data-testid={testIds['fileUplpoad-component-wrapper']}>
          <div className={styles.fieldBox}>
            <input
              className={styles.file}
              type="file"
              ref={inputFileRef}
              name={name}
              accept={accept}
              data-testid={testIds['fileUplpoad-component']}
              onChange={handleOnChange}
            />
            <img src={upload_icon} alt="" />
            <div className={styles.label}>
              Drag & Drop or <span onClick={() => inputFileRef.current.click()}>Choose file</span>{' '}
              to upload
            </div>
            <div className={styles.subLabel}>
              Only {extentions.join(', ')} with max size of {fileSize}
            </div>
          </div>
        </div>
      )}
      {file && (
        <div className={styles.uploadedFileWrapper}>
          <div className={styles.uploadedFile}>
            <div className={styles.docs}>
              <img src={doc_icon} alt="" />
            </div>
            <div className={styles.content}>
              <label>{file.fileName}</label>
              <span>{file.fileSize}</span>
            </div>
          </div>
          {!readOnly && (
            <img
              className={styles.crossIcon}
              src={delete_icon}
              height="20px"
              width="20px"
              alt=""
              onClick={() => {
                onChange({ name, value: null });
                setFile(null);
              }}
              data-testid={testIds['fileUpload-cross-icons']}
            />
          )}
        </div>
      )}
      {meta.error && meta.formSubmitted && <div className={styles.error}>{meta.error}</div>}
    </div>
  );
};

FileUplaod.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  title: PropTypes.string,
  fileSize: PropTypes.string,
  extentions: PropTypes.string,
  onChange: PropTypes.func,
  accept: PropTypes.string,
  meta: PropTypes.object,
  value: PropTypes.string,
  downloadAction: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  errorCallBack: PropTypes.func
};

export default FileUplaod;
